module.exports = __webpack_public_path__ + "static/media/bloop.213e3215.svg";